import { ComponentType } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Box, Stack } from "@mui/material";
import { theme } from "@src/theme";

// Specific icon type avoids expensive ElementType comparison (saves ~730ms in tsc)
type IconProps = { size: number; color: string };

type MobileEmptyStateProps = {
  icon: ComponentType<IconProps>;
  title: string;
  description: string;
};

export const MobileEmptyState = (props: MobileEmptyStateProps) => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        height: "100%",
        paddingY: "25vh",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          bgcolor: theme.igPrimitives.gray[600],
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <props.icon size={28} color={theme.igPrimitives.gray.A200} />
      </Box>
      <IgTypography
        variant="body1"
        fontWeight={600}
        sx={{ paddingTop: 4 }}
        color={theme.igPrimitives.gray.A400}
      >
        {props.title}
      </IgTypography>
      <IgTypography
        variant="body1"
        sx={{ paddingTop: 2, maxWidth: 280 }}
        color={theme.igPrimitives.gray.A400}
      >
        {props.description}
      </IgTypography>
    </Stack>
  );
};
